import { createFileRoute } from "@tanstack/react-router"

const parseNumberSearchParam = (value: unknown) => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : undefined
  }

  if (typeof value !== "string" || value.trim() === "") {
    return undefined
  }

  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : undefined
}

export const Route = createFileRoute("/map/")({
  validateSearch: (search) => ({
    stationId:
      typeof search.stationId === "string" ? search.stationId : undefined,
    lat: parseNumberSearchParam(search.lat),
    lng: parseNumberSearchParam(search.lng),
    zoom: parseNumberSearchParam(search.zoom),
  }),
})
